import React from 'react';
import { TrendingUp, TrendingDown, ShieldCheck, Wallet } from 'lucide-react';

const ExpenseSummaryHeaderComponent = ({
  seasonChips,
  seasonFilter,
  onSeasonChange,
  groupSurplus,
  groupLagging,
  poolExpenses,
  adminName,
  hasMembers,
  hasTransactions,
  isAdmin,
  onChangePoolOwner,
  theme,
}) => {
  const showGroupStats = hasMembers;
  const available = groupSurplus - (poolExpenses || 0);

  return (
    <>
      {/* Season Filter Chips */}
      {(seasonChips.length > 0 || hasTransactions) && (
        <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
          <button
            type="button"
            onClick={() => onSeasonChange(null)}
            className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${
              seasonFilter === null
                ? 'bg-blue-500 text-white'
                : `${theme.backgroundSecondary} border ${theme.border} ${theme.textSecondary}`
            }`}
          >
            All
          </button>
          {seasonChips.map(chip => {
            const isActive =
              seasonFilter?.season === chip.season &&
              seasonFilter?.seasonYear === chip.seasonYear;
            return (
              <button
                key={`${chip.seasonYear}-${chip.season}`}
                type="button"
                onClick={() => onSeasonChange(chip)}
                className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold transition-all ${
                  isActive
                    ? 'bg-blue-500 text-white'
                    : `${theme.backgroundSecondary} border ${theme.border} ${theme.textSecondary}`
                }`}
              >
                {chip.season} {chip.seasonYear}
              </button>
            );
          })}
        </div>
      )}

      {/* Group Admin Balance Strip */}
      {showGroupStats && (
        <div className={`rounded-2xl border ${theme.border} ${theme.card} overflow-hidden`}>
          <div className={`flex flex-wrap items-center gap-x-2 gap-y-0.5 px-4 py-2.5 border-b ${theme.border} ${theme.backgroundSecondary}`}>
            <ShieldCheck className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
            <span className={`text-xs font-semibold uppercase tracking-wide ${theme.textSecondary}`}>
              Group Overview
            </span>
            {isAdmin ? (
              <button
                type="button"
                onClick={onChangePoolOwner}
                className={`text-xs ${theme.textSecondary} hover:text-emerald-500 transition-colors`}
              >
                (Pool Owner: <span className="font-semibold underline underline-offset-2">{adminName || 'Not set'}</span>)
              </button>
            ) : (
              <span className={`text-xs ${theme.textSecondary}`}>
                (Pool Owner: <span className={`font-semibold ${theme.text}`}>{adminName || 'Not set'}</span>)
              </span>
            )}
          </div>
          <div className="grid grid-cols-3 divide-x divide-inherit">
            <div className={`p-4 border-r ${theme.border}`}>
              <div className="flex items-center gap-1.5 mb-1">
                <TrendingUp className="w-3.5 h-3.5 text-emerald-500" />
                <span className={`text-xs font-semibold uppercase tracking-wide ${theme.textSecondary}`}>
                  Received
                </span>
              </div>
              <p className="text-xl font-bold text-emerald-500">${groupSurplus.toFixed(0)}</p>
              <p className={`text-xs ${theme.textSecondary} mt-0.5`}>paid into pool</p>
            </div>
            <div className={`p-4 border-r ${theme.border}`}>
              <div className="flex items-center gap-1.5 mb-1">
                <TrendingDown className="w-3.5 h-3.5 text-red-500" />
                <span className={`text-xs font-semibold uppercase tracking-wide ${theme.textSecondary}`}>
                  Expenses
                </span>
              </div>
              <p className="text-xl font-bold text-red-500">${(poolExpenses || 0).toFixed(0)}</p>
              <p className={`text-xs ${theme.textSecondary} mt-0.5`}>spent from pool</p>
            </div>
            <div className="p-4">
              <div className="flex items-center gap-1.5 mb-1">
                <Wallet className="w-3.5 h-3.5 text-blue-500" />
                <span className={`text-xs font-semibold uppercase tracking-wide ${theme.textSecondary}`}>
                  Available
                </span>
              </div>
              <p className={`text-xl font-bold ${available >= 0 ? 'text-blue-500' : 'text-red-500'}`}>
                ${available.toFixed(0)}
              </p>
              <p className={`text-xs ${theme.textSecondary} mt-0.5`}>net pool balance</p>
            </div>
          </div>
          {groupLagging > 0 && (
            <div className={`flex items-center justify-between px-4 py-2.5 border-t ${theme.border} ${theme.backgroundSecondary}`}>
              <div className="flex items-center gap-1.5">
                <TrendingDown className="w-3.5 h-3.5 text-orange-500" />
                <span className={`text-xs font-semibold uppercase tracking-wide ${theme.textSecondary}`}>Pending contributions</span>
              </div>
              <span className="text-sm font-bold text-orange-500">${groupLagging.toFixed(0)} still owed</span>
            </div>
          )}
        </div>
      )}

    </>
  );
};

export default ExpenseSummaryHeaderComponent;
